var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CenterContent',{attrs:{"size":_vm.size}},[_vm._t("default"),_c('Button',{attrs:{"outlined":"","block":"","class-div-object":['mt-5'],"title":"Return to Showcase Page"},on:{"onClick":function($event){return _vm.$router.push({ name: 'demo' })}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }